// extracted by mini-css-extract-plugin
export default {"customCard":"KpiCard_customCard__-kGyI","dateText":"KpiCard_dateText__QpgCF","high":"KpiCard_high__ZxwWd","low":"KpiCard_low__B++Pf"};